import { render, staticRenderFns } from "./SellerDetail.vue?vue&type=template&id=4594d148&"
import script from "./SellerDetail.vue?vue&type=script&lang=js&"
export * from "./SellerDetail.vue?vue&type=script&lang=js&"
import style0 from "@@/core/pages/SalesManagement/SalesManagementSellerDetail/SellerDetailStyle.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports